import {
  LOADING_SETTINGS_HISTORY,
  NOTIFY_DANGER,
  PAYMENT_INFO_SUCCESS,
  SETTINGS_HISTORY_SUCCESS,
} from './action-types'
import { request } from './auth-actions'
import { notify } from './notification-actions'
import { genericError, silentError } from './action-utils'
import paymentServiceProxyApi from '../../api/payment-service-proxy-api'
import auditServiceApi, { TypeFilters } from '../../api/audit-service-api'
import { getText } from '../../internal/TextLabels'
import { Roles } from '../../models/roles'
import { isUserInRole, userHasAuthority } from '../../util/helpers'
import { Authorities } from '../../models/authorities'

const paymentInfoSuccess = response => ({
  type: PAYMENT_INFO_SUCCESS,
  response,
})

const settingsHistorySucess = response => ({
  type: SETTINGS_HISTORY_SUCCESS,
  response,
})

const settingsHistoryLoading = loading => ({
  type: LOADING_SETTINGS_HISTORY,
  loading,
})

export const getPaymentInfo = id => dispatch => {
  return dispatch(request(paymentServiceProxyApi.getPaymentInfo, id))
    .then(data => {
      dispatch(paymentInfoSuccess(data))
    })
    .catch(error => {
      if (error.status === 404) {
        notify(
          NOTIFY_DANGER,
          getText('paymentSettings.paymentInformation.error404'),
        )
      } else if (error.status === 500) {
        silentError(error)

        notify(
          NOTIFY_DANGER,
          getText('paymentSettings.paymentInformation.error500'),
        )
      } else {
        genericError(error)
      }
    })
}

const createEventDescription = event => ({
  ...event,
  description: getText(`settingsHistory.${event.system}.${event.type}`, {
    _action: getText(`settingsHistory.actions.${event.action}`),
    ...event.parameters,
  }),
})

export const getSettingsHistory =
  ({ page = 0, size = 20 } = {}) =>
  (dispatch, getState) => {
    dispatch(settingsHistoryLoading(true))

    const auth = getState().auth
    const filter = {
      includeTypes: {},
    }
    if (!isUserInRole(auth, Roles.RESURS_ADMIN)) {
      if (userHasAuthority(auth, Authorities.SETTINGS)) {
        Object.assign(filter.includeTypes, TypeFilters.CONFIGURATION_SERVICE)
      }
      if (userHasAuthority(auth, Authorities.USER_ADMINISTRATION)) {
        Object.assign(filter.includeTypes, TypeFilters.USER_SERVICE)
      }
    }

    return dispatch(request(auditServiceApi.getHistory({ page, size, filter })))
      .then(data => {
        dispatch(
          settingsHistorySucess({
            ...data,
            content: (data.content || []).map(createEventDescription),
          }),
        )
        dispatch(settingsHistoryLoading(false))
      })
      .catch(error => {
        dispatch(settingsHistoryLoading(false))
        genericError(error)
        throw error
      })
  }
